import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from 'Components';
import {escrowDetailList, stockScreening,} from '../../service/shipRequest';
import {Button} from "antd";
import {config} from 'Utils';
import moment from "moment";


class EscrowDetailQuery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            stockType: [],
            rows: [],
            total: 0,
            loading: false,
            btnLoading: false,
            searchObj: {
                itemNum: '',
                itemDesc: '',
                organizationId: '',
                orderNumber: '',
                closeHomologous: '',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            },
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);

    };

    routeLeaveHook(nextLocation) {
    };

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        stockScreening().then(res => {
            let arr = [];
            res.data.forEach(x => {
                arr.push({
                    text: x.delvName,
                    value: x.id
                })
            });
            this.setState({stockType: arr})
        });
    };

    goView(url) {
        hashHistory.push(url);
    };

    getData() {
        const self = this;
        const {searchObj} = this.state;
        escrowDetailList(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false})
            }
        });
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.getData();
        });
    }

    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                itemNum: '',
                itemDesc: '',
                organizationId: '',
                orderNumber: '',
                closeHomologous: '',
                bookedDateFrom: moment().add(-1, 'y').format('YYYY-MM-DD'),
                bookedDateTo: moment().format('YYYY-MM-DD'),
                p: 1,
                s: 10
            }
        }, () => {
            self.getData();
        })
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    bookedDateFrom: value.from,
                    bookedDateTo: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value.trim()}})
        }
    };

    exportList() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/shipRequest/transactionListExp`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    render() {
        const {
            rows,
            total,
            loading,
            searchObj,
            stockType
        } = this.state;


        const advanceProps = {
            fileds: [
                {
                    name: 'itemNum',
                    label: '物料编码',
                    text: '输入物料编码',
                    defaultValue: searchObj.itemNum,
                    type: 'default'
                }, {
                    name: 'itemDesc',
                    label: '物料名称',
                    text: '输入物料名称',
                    defaultValue: searchObj.itemDesc,
                    type: 'default'
                }, {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    defaultValue: searchObj.orderNumber,
                    type: 'default'
                }, {
                    name: 'closeHomologous',
                    label: '结算对应号',
                    text: '输入结算对应号',
                    defaultValue: searchObj.closeHomologous,
                    type: 'default'
                }, {
                    name: 'organizationId',
                    label: '库存组织',
                    text: '选择库存组织',
                    defaultValue: searchObj.organizationId,
                    type: 'select',
                    multiple: false,//支持多选
                    options: stockType
                }, {
                    name: 'orderTime',
                    label: '发出时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startBookDate || '',
                        end: searchObj.endBookDate || ''
                    },
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };


        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '托管单位',
                    dataIndex: 'salesUnitName'
                }, {
                    title: '库存组织',
                    dataIndex: 'organizationName'
                }, {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                }, {
                    title: '结算对应号',
                    dataIndex: 'closeHomologous'
                }, {
                    title: '登记日期',
                    dataIndex: 'bookedDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                }, {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                }, {
                    title: '订单数量',
                    dataIndex: 'orderedQuantity'
                }, {
                    title: '未发数量',
                    dataIndex: 'unShippedQuantity'
                }, {
                    title: '单据编号',
                    dataIndex: 'txnNumber'
                }, {
                    title: '转移数量',
                    dataIndex: 'transactionQuantity'
                }, {
                    title: '在途数量',
                    dataIndex: 'ztQuantity'
                }, {
                    title: '入库数量',
                    dataIndex: 'rkQuantity'
                }, {
                    title: '发出时间',
                    dataIndex: 'transactionDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                }
            ],
            rows
        };

        return <div className="dms-body">
            <DmsTab options={[`托管在途查询`]} defaultKey={0}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                {/*<div style={{marginBottom: 35}}>*/}
                {/*    <Button style={{position: 'absolute', right: 13}} icon="export"*/}
                {/*            onClick={this.exportList.bind(this)}>导出</Button>*/}
                {/*</div>*/}
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(EscrowDetailQuery);


// WEBPACK FOOTER //
// ./src/routes/shipRequest/escrowDetailQuery.js